// Hub ID for js.hs-scripts.com/3268782.js (src/common/util/tagManager.js) — same portal.
const HUBSPOT_PORTAL_ID = "3268782";

// GUID of the "Gospel Runners abandoned donation" form in HubSpot (Marketing >
// Forms). It's never published/embedded anywhere — it only exists so HubSpot
// can hand out this GUID and enroll submissions into the follow-up email workflow.
export const GOSPEL_RUNNER_ABANDONED_CART_FORM_GUID = "86194d66-4e9f-4f72-a7a6-43bbe77e82c8";

function getHubspotTrackingCookie() {
  const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
  return match ? match[1] : undefined;
}

// Submits directly to HubSpot's Forms submission endpoint. Unlike the
// contacts/subscriptions API in ./api.js, this endpoint takes no auth
// header, so it can be sent via navigator.sendBeacon — which is what makes
// it reliable to call from a "pagehide" handler (a normal fetch/XHR can be
// cancelled by the browser mid-flight when the page is unloading).
export function submitHubspotForm(formGuid, fieldValues) {
  const fields = Object.entries(fieldValues)
    .filter(([, value]) => !!value)
    .map(([name, value]) => ({ name, value }));

  if (!fields.length) return;

  const payload = {
    fields,
    context: {
      pageUri: window.location.href,
      pageName: document.title,
      hutk: getHubspotTrackingCookie(),
    },
  };

  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${formGuid}`;
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    mode: "cors",
    credentials: "omit",
    keepalive: true,
  });
}

export function submitAbandonedCartForm({ firstName, lastName, email }) {
  return submitHubspotForm(GOSPEL_RUNNER_ABANDONED_CART_FORM_GUID, {
    email,
    firstname: firstName,
    lastname: lastName,
  });
}
